"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.query = exports.Query = undefined;

var _utilsMain = require("./utils.main.js");

var _utilsDom = require("./utils.dom.js");

/**
 * @module utils.Query
 */

/**
 * This class provides various shorthand utilities for interacting with
 * collections of dom elements
 *
 * @class Query
 */

function Query(arr) {
    var i, item;
    if (!arr) arr = [];

    if (arr instanceof Array == false && arr.nodeType == 1) arr = [arr];

    for (i = 0; item = arr[i]; i++) {
        this.push(item);
    }
}

Query.getters = {
    css: 'getStyles',
    html: 'innerHTML'
};

Query.setters = {
    css: 'setStyles',
    html: 'innerHTML'
};

Query.prototype = new Array();

/**
 * indicates the current object of the Query type
 * @property $query
 * @type {boolean}
 */
Query.prototype.$query = true;

(function () {
    /**
     * If collection has one element, will return the value of the specified property
     * Else return an array of values
     *
     * @method get
     * @param {string} name property name
     *
     * @returns {Array|*}
     */
    Query.prototype.get = function (name) {
        var is_array = this.length > 1,
            getter = Query.getters[name],
            is_fn = typeof this[getter] == 'function',
            values = [];

        if (is_fn) return this[getter]();

        if (getter) name = getter;

        this.forEach(function (el) {
            var value = name.indexOf('offset') != 0 ? el.getAttribute(name) : el[name];

            values.push(value);
        });

        return is_array ? values : values[0];
    };

    /**
     * Set the value of a given property for all instances in the collection
     *
     * @method set
     * @param name
     * @param value
     *
     * @chainable
     */
    Query.prototype.set = function (name, value) {
        var setter = Query.setters[name],
            is_fn = typeof this[setter] == 'function';

        if (is_fn) return this[setter](value);

        if (setter) name = setter;

        this.forEach(function (el) {
            el.setAttribute(name, value);
        });

        return this;
    };
})();

/**
 * inserts this collection after another node
 *
 * @method insertAfter
 * @param {node} target
 * @chainable
 * @alias insertBefore
 */
Query.prototype.appendBefore = function (element) {
    var frag = document.createDocumentFragment();

    this.forEach(function (el) {
        frag.appendChild(el);
    });

    _utilsDom.dom.appendBefore(frag, element);

    return this;
};

/**
 * inserts this collection  before another node
 *
 * @method insertAfter
 * @param {node} target
 * @chainable
 * @alias insertBefore
 */
Query.prototype.appendAfter = function (element) {
    var frag = document.createDocumentFragment();

    this.forEach(function (el) {
        frag.appendChild(el);
    });

    _utilsDom.dom.appendAfter(frag, element);

    return this;
};

/**
 * return the parent element/s of this collection
 * @method parent
 * @returns {Query}
 */
Query.prototype.parent = function () {
    var arr = [];

    this.forEach(function (el) {
        arr.push(el.parentNode);
    });

    return new Query(arr);
};

/**
 * Inserts the child/ren into the current element using the `insertByProp` method
 *
 * See more at {{#crossLink "utils.DOM/insertByProp"}}{{/crossLink}}
 *
 * @method insertByProp
 * @param {Element} el
 * @param {string}  property
 *
 * @chainable
 */
Query.prototype.insertByProp = function (child, prop) {
    var parent = this[0];

    if (!child.forEach) child = [child];

    child.forEach(function (el) {
        _utilsMain.main.dom.insertByProp(el, prop, parent);
    });

    return this;
};

/**
 * returns the offset of this element to a relative parent
 * @param dir
 * @param parent
 * @returns {*|int}
 */
Query.prototype.getOffset = function (dir, parent) {
    return _utilsMain.main.dom.getOffset(dir, this, parent);
};

/**
 * checks if a given parent is the parent of this element
 * @param parent
 * @returns {boolean}
 */
Query.prototype.isParent = function (parent) {
    if (parent.$query) return parent.isChild(this);
    return _utilsMain.main.dom.isDescendantOf(this, parent);
};

/**
 * checks if a given child is a child of one of the elements in this collection
 * @param child
 * @returns {boolean}
 */
Query.prototype.isChild = function (child) {
    var ret = false;

    this.forEach(function (el) {
        if (!ret) {
            ret = _utilsMain.main.dom.isDescendantOf(child, el);
        }
    });

    return ret;
};

Query.prototype.concat = function (arr) {
    var arr,
        i,
        $this = this;

    for (i = 0; arr = arguments[i]; i++) {
        arr.forEach(function (item) {
            $this.push(item);
        });
    }
};

Query.prototype.getElements = function (list) {
    var results = {};

    this.forEach(function (el) {
        var result, key;

        for (key in list) {
            result = el.querySelectorAll(list[key]);
            results[key] = new Query(result);
        }
    });

    return results;
};

Query.prototype.addEvent = function (ev, name, capture) {
    this.addEventListener(ev, name, capture);
    return this;
};

Query.prototype.addEvents = function (obj) {
    var key;

    for (key in obj) {
        this.addEventListener(key, obj[key]);
    }return this;
};

Query.prototype.removeEvent = function (ev, name, capture) {
    this.removeEventListener(ev, name, capture);
    return this;
};

/**
 * Look for a selector within all elements in the collection and return the resulting collection
 * @method $
 * @param selector
 * @returns {Query}
 */
Query.prototype.$ = function (selector) {
    var result = [];

    this.forEach(function (el) {
        var list = [].slice.call(el.querySelectorAll(selector));
        result = result.concat(list);
    });

    return new Query(result);
};

/**
 * DOM Methods and properties
 * All native DOM methods and properties are accessible:
 *  * setter methods will be called on all elements in the collection
 *  * getter methods will return the value of the first value to be received
 *  * property access will alway return the property of the first element in the collection
 *
 * @method DOM
 */
//Wrap native DOM methods
(function () {
    var el = document.createElement('input'),
        name;

    function defineAccessors(obj, name) {
        function _get() {
            return this[0] ? this[0][name] : null;
        }

        function _set(value) {
            if (this[0]) this[0][name] = value;
        }

        if (Object.defineProperty) {
            Object.defineProperty(obj, name, {
                get: _get,
                set: _set
            });
        } else if (obj.__defineGetter__) {
            obj.__defineGetter__(name, _get);
            obj.__defineSetter__(name, _set);
        }
    }

    function wrap(name) {
        return function (els) {
            var args = [].slice.call(arguments),
                value,
                item,
                i;

            if (els instanceof Query) args[0] = els[0];

            for (i = 0; item = this[i]; i++) {
                value = this[i][name].apply(this[0], args);
                if (value) return value;
            }
        };
    }

    for (name in el) {
        if (typeof el[name] == 'function') Query.prototype[name] = wrap(name);else defineAccessors(Query.prototype, name);
    }
})();

/**
 * Same as calling `query.get('offsetWidth|Height|LeftTop')`
 *
 * @method get[Height|Width|Top|Left]
 * @return {Array|number}
 */
/**
 * Same as calling `query.set('offsetWidth|Height|Left|Top',x)`
 *
 * @method set[Height|Width|Top|Left]
 * @param  {number} value
 * @chainable
 */
(function (list) {
    list.forEach(function (prop) {
        var camelized = prop[0].toUpperCase() + prop.substr(1),
            prop_name = 'offset' + camelized,
            set_name = 'set' + camelized,
            get_name = 'get' + camelized;

        Query.prototype[set_name] = function (value) {
            var args = {};
            args[prop] = value;
            return this.setStyles(args);
        };

        Query.prototype[get_name] = function () {
            return this.get(prop_name);
        };
    });
})(['top', 'left', 'height', 'width']);

/**
 * get the first element child of all elements in collection
 * @method getFirstChild
 * @return {Query}
 */

/**
 * returns the next sibling of all elements in the collection
 * @method getNext
 * @return {Query}
 */
//Alias element fetching methods
(function (list) {
    var i, name;

    function wrap(method) {

        return function () {
            var arr = [],
                args = [].slice.call(arguments);

            args.unshift(null);

            this.forEach(function (el) {
                args[0] = el;
                var result = _utilsDom.dom[method].apply(_utilsDom.dom, args);
                if (result) arr.push(result);
            });

            return new Query(arr);
        };
    }

    for (i = 0; name = list[i]; i++) {
        Query.prototype[name] = wrap(name);
    }
})(['getFirstChild', 'getNext']);

/**
 * Adds a class/list of classes to all elements in the collection
 * @method addClass
 * @param {string} name
 * @chainable
 */

/**
 * removes a class/list of classes from all elements in the collection
 * @method removeClass
 * @param {string} name
 * @chainable
 */

/**
 * toggles a class/list of classes from all elements in the collection
 * @method toggleClass
 * @param {string} name
 * @chainable
 */

/**
 * same as  {{#crossLink "utils.DOM/setStyles"}}{{/crossLink}}
 *
 * @method setStyles
 * @chainable
 * @alias css
 */
(function (list) {
    var i, name;

    function wrap(method) {
        return function () {
            var args = [].slice.call(arguments);

            args.unshift(null);

            this.forEach(function (el) {
                args[0] = el;
                _utilsDom.dom[method].apply(_utilsDom.dom, args);
            });

            return this;
        };
    }

    for (i = 0; name = list[i]; i++) {
        Query.prototype[name] = wrap(name);
    }
})(['addClass', 'removeClass', 'toggleClass', 'setStyles', 'setHTML']);

//Alias getter methods
(function (list) {
    var i, name;

    function wrap(method) {
        return function () {
            var value = '',
                args = [].slice.call(arguments);

            args.unshift('');

            this.forEach(function (el) {
                args[0] = el;
                value = _utilsDom.dom[method].apply(_utilsDom.dom, args);
            });

            return value;
        };
    }

    for (i = 0; name = list[i]; i++) {
        Query.prototype[name] = wrap(name);
    }
})(['getStyle', 'getStyles', 'getGlobalPosition', 'getElementSize', 'getCoords', 'matchesSelector', 'hasClass']);

//Alias native DOM methods with normal methods
Query.alias = function (name) {
    var obj = name;

    for (name in obj) {
        Query.prototype[name] = Query.prototype[obj[name]];
    }
};

Query.alias({
    'on': 'addEvent',
    'off': 'removeEvent',
    'append': 'appendChild',
    'matches': 'matchesSelector',
    'insertBefore': 'appendBefore',
    'insertAfter': 'appendAfter',
    'html': 'setHTML',
    'getSize': 'getElementSize'
});

_utilsMain.main.$ = function (selector, scope) {
    if (scope instanceof Query) return scope.$(selector);

    if (selector instanceof Query) return selector;

    if (!arguments.length || selector.nodeType == 1 || selector instanceof Array) return new Query(selector);

    if (!Query.document) Query.document = new Query([document]);

    return Query.document.$(selector);
};

_utilsMain.main.Query = Query;
Query.body = _utilsMain.main.$('body');

exports.Query = Query;
var query = exports.query = Query;


//////////////////
// WEBPACK FOOTER
// ./~/ereader-core/dist/utils.query.js
// module id = 650
// module chunks = 0